import { take } from 'rxjs/operators';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SearchService } from '@core/services/search.service';
import { TouchPoint } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { BreakpointService } from '@libs/breakpoints';
import { ProductSearchViewModel } from '@models/api-search.models';
import { UmbracoImage } from '@models/umbraco.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointIsPipe } from '../../../@shared/breakpoint/breakpoint-is.pipe';
import { ProductPriceComponent } from '../../product/product-price/product-price.component';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../../../@shared/image/image/image.component';
import { NgIf, NgFor, NgStyle, AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-image-touch-point',
    templateUrl: './image-touch-point.component.html',
    styleUrls: ['./image-touch-point.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, ImageComponent, NgFor, NgStyle, RouterLink, ProductPriceComponent, AsyncPipe, BreakpointIsPipe]
})
export class ImageTouchPointComponent implements OnInit {
    @Input()
    public image: UmbracoImage;

    @Input()
    public touchPoints: (TouchPoint & {
        details?: ProductSearchViewModel;
    })[];

    constructor(
        private cd: ChangeDetectorRef,
        public breakpointService: BreakpointService,
        private searchService: SearchService
    ) {}

    ngOnInit(): void {
        if (!this.touchPoints.length) {
            return;
        }

        this.searchService
            .getProducts(...this.touchPoints.map(point => point.productId))
            .pipe(take(1), untilDestroyed(this))
            .subscribe(({ products }) => {
                if (products?.length) {
                    this.touchPoints = this.touchPoints.map(point => {
                        const currentSum = products.find(pointSum => pointSum.variantNo === point.productId);

                        return {
                            ...(currentSum ? { details: currentSum } : {}),
                            ...point
                        };
                    });

                    this.cd.markForCheck();
                }
            });
    }

    public checkPosition(element: HTMLDivElement, wrapper: HTMLDivElement): void {
        if (!element || !wrapper) {
            return;
        }

        const { left } = element.getBoundingClientRect();
        const { left: wrapperLeft } = wrapper.getBoundingClientRect();
        const offsetLeft = left + element.offsetWidth;
        const wrapperOffset = wrapperLeft + wrapper.offsetWidth;

        if (offsetLeft > wrapperOffset) {
            element.style.transform = `translateX(-${offsetLeft - wrapperOffset}px)`;
        }
    }
}
